import { render, staticRenderFns } from "./sales_footer.vue?vue&type=template&id=4d19d8f4&"
import script from "./sales_footer.vue?vue&type=script&lang=js&"
export * from "./sales_footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports